import React from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import {
	BooleanInput,
	Datagrid,
	EditButton,
	Filter,
	List,
	ListBase,
	useListContext,
} from "react-admin";
import { Button, CardMedia, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import querystring from "query-string";
import { SelectCampaignStatusInput } from "../../fields/SelectCampaignStatus";

const useStyles = makeStyles({
	root: {
		marginTop: "1em",
	},
	media: {
		height: 140,
	},
	title: {
		paddingBottom: "0.5em",
	},
	actionSpacer: {
		display: "flex",
		justifyContent: "space-around",
	},
	icon: { paddingRight: "0.5em" },
	linkDonation: {
		display: "inline-flex",
		alignItems: "center",
	},
});

const LinkToRelatedDonations = ({ record }) => {
	const classes = useStyles();
	return (
		<Button
			size="small"
			color="primary"
			component={Link}
			to={{
				pathname: "/donation",
				search: querystring.stringify({
					filter: JSON.stringify({ campaign_id: record.id }),
				}),
			}}
			className={classes.linkDonation}
		>
			Dons
		</Button>
	);
};

const BASE_URL = process.env.REACT_APP_ENV === 'staging' ? 'https://omf-cf-ui-staging.web.app' : 'https://omf-cf-ui.web.app'

const OpenPreviewButton = ({ record }) => {
	return record.status === "CAMPAIGN_STATUS_DRAFT" ? (
		<Button href={`${BASE_URL}/preview${record.url}`} target="_blank">
			Voir preview
		</Button>
	) : (
		<Button href={`${BASE_URL}/${record.url}`} target="_blank">
			Voir campagne
		</Button>
	);
};

const CampaignFilters = (props) => (
	<Filter {...props}>
		<SelectCampaignStatusInput label="Statut" />
		<BooleanInput source="is_pinned" label="A la une" />
	</Filter>
);

const cardStyle = {
	width: 300,
	minHeight: 300,
	margin: "0.5em",
	display: "inline-block",
	verticalAlign: "top",
};
const CampaignGrid = (props) => {
	const classes = useStyles(props);
	const { data } = useListContext();

	return data ? (
		<Grid container spacing={2} className={classes.root}>
			{data.map((record) => (
				<Grid key={record.id} xs={12} sm={6} md={4} lg={3} xl={2} item>
					<Card>
							<Link to={`/campaign/${record.id}/show`}>
								<CardMedia image={record.abstract_image} className={classes.media} />
							</Link>
							<CardContent className={classes.title}>
								<Typography variant="h5" component="h2" align="center">
									{record.title}
								</Typography>
							</CardContent>
							<CardActions classes={{ spacing: classes.actionSpacer }}>
								<LinkToRelatedDonations record={record} />
								<OpenPreviewButton record={record} />
								<EditButton basePath="/campaign" record={record} label="modifier" />
							</CardActions>
						</Card>
				</Grid>
			))}
		</Grid>
	) : null;
};

const CampaignList = (props) => (
	<List
		{...props}
		filters={<CampaignFilters />}
		component="div"
		sort={{
			field: "created_date",
			order: "DESC",
		}}
	>
		<CampaignGrid />
	</List>
);

export default CampaignList;
